import type { GenieKnowledgeEntry } from '../../types';

export const ulnarNeuropathyElbow: GenieKnowledgeEntry = {
  id: 'ulnar_neuropathy_elbow',
  name: 'Neuropatía Cubital en Codo',
  category: 'neuropatico',
  conversation: {
    headline:
      'Atrapamiento del cubital en el canal cubital o epitroclea. Caída de amplitud codo vs muñeca localiza la lesión.',
    edxHighlights: [
      'Caída de CMAP >20% entre muñeca y codo (segmento across-elbow)',
      'Inching de 1 cm a través del codo localiza el sitio exacto',
      'Descartar anastomosis Martin-Gruber antes de diagnosticar bloqueo',
      'EMG: fibrilaciones en FDI/ADM/interóseos con PUMs neurogénicos',
    ],
    pearls: [
      'Martin-Gruber: CMAP de muñeca > codo (falso bloqueo) — estimular por debajo del codo.',
      'Flexión prolongada del codo durante el estudio puede simular neuropatía.',
    ],
    nextSteps: [
      'Estudios segmentarios (inching) si la caída es borderline',
      'Correlacionar con parestesias 4.º-5.º dedo y debilidad intrínsecos',
    ],
  },
  orientationHints: {
    temporalFit: ['chronic'],
    whenToSuspect: 'Parestesias ulnares, debilidad intrínsecos, codo apoyado crónicamente',
  },
};
